// extracted by mini-css-extract-plugin
export default {"newsItem":"newsCard_newsItem__5fUml","newsItemTitle":"newsCard_newsItemTitle__RzoKG","newsItemDate":"newsCard_newsItemDate__xcHEN"};